<template>
    <div
        class="search-result"
        :class="{ isActive: id === activeId}"
        @click.prevent="$emit('click', resultUrl(data.id))"
    >
        <div
            v-if="data.firstname || data.lastname"
            class="header"
        >
            {{ data.firstname !== null ? data.firstname : '' }} {{ data.lastname !== null ? data.lastname : '' }} ({{ data.id }})
            <div
                v-if="data.company"
                class="subline"
            >
                {{ data.company }}
            </div>
        </div>
        <div
            v-else
            class="header"
        >
            {{ data.company }} ({{ data.id }})
        </div>
        <div
            v-if="data.brand_customer_number"
            class="subline"
        >
            {{ data.brand_customer_number }}
        </div>
    </div>
</template>

<script>

export default {
    name: 'SearchResultCustomer',
    props: {
        data: {
            type: Object,
            default: () => {
                return null
            }
        },
        id: {
            type: Number,
            default: () => {
                return null
            }
        },
        activeId: {
            type: Number,
            default: () => {
                return null
            }
        }
    },
    emits: ['click'],
    created () {
        window.addEventListener('keydown', this.handleKeys)
    },
    unmounted () {
        window.removeEventListener('keydown', this.handleKeys)
    },
    methods: {
        resultUrl (customerId) {
            return this.$route('customers.customers.show', {
                customer: customerId
            })
        },
        handleKeys (event) {
            // ENTER
            if (event.code === 'Enter') {
                this.$emit('click', this.resultUrl(this.data.id))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search-result {
    padding: 15px 25px;
    transition: 0.2s ease-in-out all;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    text-decoration: none;

    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }
    & .header {
        font-weight: bold;
        font-size: 16px;
        color: #222;
        background: transparent;
    }
    & .subline {
        color: rgba(0,0,0,0.6);
    }
}
.isActive {
    background: rgba(0,0,0,0.07);
}
</style>
